import { Stack, Typography } from "@mui/material";
import moment from "moment";

export default function InfoContabeis({ resposta }: InfoContabeisProps) {
  const {
    local_cobranca,
    departamento,
    data_vencimento,
    forma_pagamento,
    conta_corrente,
    data_emissao
  } = resposta;

  return (
    <Stack>
      {local_cobranca?.codigo && local_cobranca?.nome && (
        <Typography variant="caption" component="div" my={0.5}>
          Local de Cobrança:{" "}
          <b>
            {local_cobranca.codigo} - {local_cobranca.nome}
          </b>
        </Typography>
      )}
      {departamento?.id && departamento?.nome && (
        <Typography variant="caption" component="div" my={0.5}>
          Departamento:{" "}
          <b>
            {departamento.id} - {departamento.nome}
          </b>
        </Typography>
      )}
      {data_vencimento && (
        <Typography variant="caption" component="div" my={0.5}>
          Vencimento: <b>{moment(data_vencimento).format("DD/MM/YYYY")}</b>
        </Typography>
      )}
      {data_emissao && (
        <Typography variant="caption" component="div" my={0.5}>
          Data emissão: <b>{moment(data_emissao).format("DD/MM/YYYY")}</b>
        </Typography>
      )}
      {forma_pagamento && (
        <Typography variant="caption" component="div" my={0.5}>
          Forma de Pagamento: <b>{forma_pagamento}</b>
        </Typography>
      )}
      {conta_corrente && (
        <Typography variant="caption" component="div" my={0.5}>
          Conta corrente:
          <b>
            {conta_corrente.banco.nome} {conta_corrente.conta}
            {conta_corrente.conta_digito &&
            conta_corrente.conta_digito.trim() !== ""
              ? `-${conta_corrente.conta_digito}`
              : ""}{" "}
            {conta_corrente.agencia}
            {conta_corrente.agencia_digito &&
            conta_corrente.agencia_digito.trim() !== ""
              ? `-${conta_corrente.agencia_digito}`
              : ""}
          </b>
        </Typography>
      )}
    </Stack>
  );
}

interface InfoContabeisProps {
  resposta: IInformacoesContabeis;
}

export interface IInformacoesContabeis {
  local_cobranca: ILocalCobranca;
  departamento: IDepartamento;
  data_vencimento: string;
  data_emissao?: string;
  forma_pagamento: string;
  conta_corrente: IContaCorrente;
}

export interface ILocalCobranca {
  codigo: number;
  nome: string;
  endereco: string;
  cep: string;
  cidade: string;
  uf: string;
}

export interface IDepartamento {
  cooperativa_id: number;
  id: number;
  nome: string;
}

export interface IContaCorrente {
  id: string;
  banco: {
    id: number;
    codigo: number;
    nome: string;
    logo_imagem: string;
    integracoes_possiveis: any | null;
  };
  agencia: string;
  agencia_digito: string;
  conta: string;
  conta_digito: string;
  tipo_conta_bancaria: string;
  tipo_cnpj_conta: string;
  conta_leite: string;
}
